import { Box, BoxProps } from "@mui/material";
import { IWikifolioWatchlistCtaData } from "src/api/server/wf-detail.types";
import { Container } from "src/components-mui/layout/container";
import { WatchlistCta } from "./watchlist-cta";

interface IWatchlistCtaSectionProps extends BoxProps {
    wikifolioId: string;
    wikifolioShortDescription: string;
    isOnWatchlist: boolean;
    data: IWikifolioWatchlistCtaData;
}
const WATCHLIST_CTA_SECTION_TEST_ID = "watchlist-cta-section-test-id";

export const WatchlistCtaSection = ({ wikifolioId, wikifolioShortDescription, isOnWatchlist, data, ...boxProps }: IWatchlistCtaSectionProps) => {
    return (
        <Box
            data-test-id={WATCHLIST_CTA_SECTION_TEST_ID}
            {...boxProps}
            sx={[{ mb: [10, 10, 14], backgroundColor: "gray.50" }, ...(Array.isArray(boxProps.sx) ? boxProps.sx : [boxProps.sx])]}
        >
            <Container>
                <WatchlistCta
                    wikifolioId={wikifolioId}
                    wikifolioShortDescription={wikifolioShortDescription}
                    isOnWatchlist={isOnWatchlist}
                    data={data}
                />
            </Container>
        </Box>
    );
};
